import { render } from "./BaseSimpleInput.vue?vue&type=template&id=4e8e5c1a"
import script from "./BaseSimpleInput.vue?vue&type=script&lang=js"
export * from "./BaseSimpleInput.vue?vue&type=script&lang=js"
script.render = render

export default script